const e = { "logged-ticket-private": "{{name}} hat dies protokolliert", view: "Ansehen", "view-ticket": "Ticket anzeigen", meeting: "Besprechung", "shared-private": "{{name}} hat dies geteilt", "logged-ticket-public": "{{name}} hat dies protokolliert", "shared-public": "{{name}} hat dies protokolliert", "crated-meeting-public": "{{name}} hat eine Besprechung geteilt", "crated-meeting-private": "{{name}} hat eine Besprechung erstellt" }, t = { ticketing: "Ticketing", messaging: "Nachrichtenversand" }, i = {
  link: e,
  category: t
};
export {
  t as category,
  i as default,
  e as link
};
